import React from 'react'
import { Link as RouterLink } from 'react-router'
import { Link as ChakraLink } from '@chakra-ui/react'

const defaultExternalStyles = {
  colorPalette: 'primary',
  variant: 'underline',
  textDecoration: 'underline'
}

export default function Link (props) {
  const { to, ...rest } = props
  if (to != null) {
    return (
      <ChakraLink
        as={RouterLink}
        to={to}
        colorPalette='primary'
        variant='underline'
        textDecoration='underline'
        {...rest}
      />
    )
  }
  return (
    <ChakraLink
      {...defaultExternalStyles}
      {...rest}
    />
  )
}
